import {
  TRANSFER_EVENT_CANCELED,
  TRANSFER_EVENT_CANCELING,
  TRANSFER_EVENT_COMPLETE,
  TRANSFER_EVENT_FAILED,
  TRANSFER_EVENT_PROGRESS,
  TRANSFER_EVENT_START,
  TRANSFER_TYPE_UPLOAD
} from './transfer-types/upload-base'

// A transfer is active while it runs: started (an upload sending, a copy
// connected or queued on the server) and not yet finished. A file only
// picked in an uploader (INIT) is not, nor is anything finished. The
// header's Transfers button shows only while one is active (owner
// 2026-10-19).
const ACTIVE = new Set([TRANSFER_EVENT_START, TRANSFER_EVENT_PROGRESS, TRANSFER_EVENT_CANCELING])
const FINISHED = new Set([TRANSFER_EVENT_COMPLETE, TRANSFER_EVENT_FAILED, TRANSFER_EVENT_CANCELED])

export const isTransferActive = transfer => !!transfer && ACTIVE.has(transfer.status)

export const isTransferFinished = transfer => !!transfer && FINISHED.has(transfer.status)

export const isTransferFailed = transfer => !!transfer && transfer.status === TRANSFER_EVENT_FAILED

export const countActiveTransfers = list => (list || []).filter(isTransferActive).length

// What the person is told when one finishes away from its own page, or
// fails anywhere (transfer-outcome-toasts.js).
export const transferFailedText = transfer =>
  transfer.type === TRANSFER_TYPE_UPLOAD
    ? `Uploading “${transfer.name}” failed. Open its page to try again.`
    : `Copying “${transfer.name}” didn't finish: the connection closed before the copy was done. Check its folder before you try again.`

export const transferCompleteText = transfer =>
  transfer.type === TRANSFER_TYPE_UPLOAD ? `Upload finished: “${transfer.name}”.` : `Copy finished: “${transfer.name}”.`
